import { createSelector } from 'reselect';

export const getScreenState = ({ eReader }) => eReader.screen;

export const getCurrentScreen = createSelector([getScreenState], screen => screen.currentScreen);
